import PageFullscreen from "./components/Fullscreen";

export default PageFullscreen;
